import React, { useState } from 'react';

import type { ToolbarContextType } from './../../../../ricos-context';
import { withToolbarContext } from './../../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../../ricos-modals/modal-service-provider';
import { decorateComponentWithProps } from './../../../../editor-common';
import {
  TEXT_COLOR_MODAL_ID,
  TEXT_HIGHLIGHT_MODAL_ID,
} from './../../../../plugin-text-color/constants';

import { ToolbarButton } from '../ToolbarButton';

const getColorButton = ({
  toolbarItem,
  context,
  dataHook,
  modalId,
}: {
  toolbarItem?: any;
  context: ToolbarContextType;
  dataHook?: string;
  modalId: string;
}) => {
  if (!context) return null;
  const { isMobile, t, getPublicCommands } = context;
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const publicCommands = getPublicCommands();
  const Icon = toolbarItem.presentation.getIcon(publicCommands);
  const tooltip = t(toolbarItem.presentation?.tooltip);
  const isModalOpen = useModalState(getIsModalOpen(modalId));

  const onClick = (event: React.MouseEvent | React.KeyboardEvent) => {
    toolbarItem.commands.click({ referenceElement, clickFromKeyboard: !event.detail });
  };

  return (
    <ToolbarButton
      active={isModalOpen}
      ref={setReferenceElement}
      disabled={toolbarItem.attributes.disabled}
      isMobile={isMobile}
      tooltip={tooltip}
      onClick={onClick}
      icon={() => <Icon />}
      dataHook={dataHook}
    />
  );
};

export const TextColorButton = withToolbarContext(
  decorateComponentWithProps(getColorButton, {
    modalId: TEXT_COLOR_MODAL_ID,
  })
);
export const HighlightColorButton = withToolbarContext(
  decorateComponentWithProps(getColorButton, {
    modalId: TEXT_HIGHLIGHT_MODAL_ID,
  })
);
